import { render, staticRenderFns } from "./Reservoirs.vue?vue&type=template&id=cb70b0fc&scoped=true&"
import script from "./Reservoirs.vue?vue&type=script&lang=js&"
export * from "./Reservoirs.vue?vue&type=script&lang=js&"
import style0 from "./Reservoirs.vue?vue&type=style&index=0&id=cb70b0fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb70b0fc",
  null
  
)

export default component.exports